<template>
  <Badge :color="badgeColor">{{ phaseLabel }}</Badge>
</template>

<script>
import Badge from '@/components/badge'

export default {
  props: {
    status: String,
    phaseLabel: String
  },

  components: {
    Badge,
  },

  computed: {
    badgeColor () {
      switch (this.status) {
        case 'running':
          return 'blue';

        case 'finished':
          return 'green';

        case 'warnings':
          return 'yellow';

        case 'failed':
          return 'red';

        default:
          return 'gray';
      }
    }
  }
}
</script>
